module.exports = __webpack_public_path__ + "static/media/gastronomia_miniatura.9edd9eed.jpg";